/**
 * ChartController — context surface the dashboard provider implements so
 * each ChartWidget instance can mutate its own config (title, period,
 * tags). The Phase-2 chart-row controller is gone (Amendment A).
 */

import React, { createContext, useContext, useMemo } from 'react';

import type { ChartPeriod } from '../../../pages/dslAgentTest/chartPeriod';
import type { DslTag } from '../../../pages/dslAgentTest/types';

export interface ChartController {
  setTitle: (title: string) => void;
  setPeriod: (period: ChartPeriod) => void;
  setTags: (tags: DslTag[]) => void;
  /** Whether this widget is frozen on the canvas. */
  pinned: boolean;
  togglePin: () => void;
  remove: () => void;
}

export interface ChartControllerProvider {
  getController: (instanceId: string) => ChartController;
}

const ChartControllerContext = createContext<ChartControllerProvider | null>(null);

export const ChartControllerProviderContext = ChartControllerContext.Provider;

export function useChartController(instanceId: string): ChartController {
  const provider = useContext(ChartControllerContext);
  if (!provider) {
    throw new Error(
      'useChartController must be used inside a ChartControllerProviderContext (MarketMonitorDashboardProvider).',
    );
  }
  return useMemo(() => provider.getController(instanceId), [provider, instanceId]);
}
